import React, {SyntheticEvent, useState} from "react";
import {v4} from "uuid";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import AirIcon from '@mui/icons-material/Air';
import StreamSharpIcon from '@mui/icons-material/StreamSharp';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Paper, Table, TableBody,
    TableCell, TableContainer,
    TableHead, TableRow
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
    s_char_disciplines, s_char_grimoirespells,
    s_char_inventarSpells,
    s_char_matrices, s_char_matricespells,
} from "../../_signals/s_char";
import Button from "@mui/material/Button";
import {ICharMatrice} from "../../_interfaces/ICharMatrice";
import {ICharInventarSpell} from "../../_interfaces/ICharInventarSpell";
import DialogLearning from "./dialogLearning";
import DialogAddInventar from "./dialogAddInventar";
import {InfoSpellSubscriber} from "../../_helper/InfoSpellBehave";
import MatriceSpellAttune from "./MatriceSpellAttune";
import MatriceSpellCasting from "./MatriceSpellCasting";
import {ICharMatriceSpell} from "../../_interfaces/ICharMatriceSpell";
import MatriceAdd from "./MatriceAdd";
import MatriceEdit from "./MatriceEdit";
import {useSignals} from "@preact/signals-react/runtime";
import EditIcon from "@mui/icons-material/Edit";
import {ICharGrimoireSpell} from "../../_interfaces/ICharGrimoireSpell";
import MatriceSpellWeaving from "./MatriceSpellWeaving";
import {InventarSpellsDelete} from "../../_api/BEInventarSpells";
import {SpellsSubscriber} from "../../_helper/DataBehaves";
import {MatricespellsUpdate} from "../../_api/BEMatricespells";
import ContentCutIcon from '@mui/icons-material/ContentCut';
import Grid from "@mui/material/Grid";
import {styled} from "@mui/material/styles";
import {s_app_mobile} from "../../_signals/s_app";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2,
    padding: 2,
    textAlign: 'center',
    color: '#000',
    width: '100%',
}));
interface IProps {
    roll:boolean
}
function MatriceSpell({roll}:IProps) {
    useSignals()

    const [learnSpellOpen, setLearnSpellOpen] = useState(false)

    const [addInventarSpellOpen, setAddInventarSpellOpen] = useState(false)

    const [attuneMatrixOpen, setAttuneMatrixOpen] = useState('')

    const [cast, setCast] = useState('')

    const [weave, setWeave] = useState('')


    const [matriceAddOpen, setMatriceAddOpen] = useState(false)

    const [matriceEditOpen, setMatriceEditOpen] = useState('')


    const removeInventarSpell = (spell: ICharInventarSpell) => {
        s_char_inventarSpells.value = s_char_inventarSpells.value.filter(is => is.id !== spell.id)
        InventarSpellsDelete(spell)
    }

    const handleSpellPopOpen = (spellname: string, event: SyntheticEvent) => {
        const spell = SpellsSubscriber.value.find(s => s.name === spellname)
        if (spell) {
            InfoSpellSubscriber.next({popEl: event.currentTarget, pop: spell, popOpen: true})
        }
    }

    const canWeave = (matrice: ICharMatrice, spell: ICharMatriceSpell) => {
        let disciplines = s_char_disciplines.value;
        const disciplin = disciplines.find((d) => d.name === spell.discipline);
        if (!disciplin) return;
        const neededThreads = spell.threads;
        const maxAdd = Math.ceil(disciplin.circle / 4);

        return spell.threadswoven < neededThreads + maxAdd;
    }

    const weaveThread = (matrice: ICharMatrice, spell: ICharMatriceSpell) => {
        setWeave(spell.id)
    }

    const castSpell = (matrice: ICharMatrice, spell: ICharMatriceSpell) => {
        setCast(spell.id)
    }

    const releaseThreads = (spell: ICharMatriceSpell) => {
        let matricespells = s_char_matricespells.value;
        matricespells = matricespells.map(ms => {
            if (spell.id === ms.id) {
                ms.threadswoven = 0;
                MatricespellsUpdate(ms)
            }
            return ms
        })
        s_char_matricespells.value = matricespells
    }

    const matrixRow = (matrice: ICharMatrice, rows: number, index: number) => {

        return <Grid container style={{margin: '0 5px', borderBottom: rows - 1 == index ? '' : '1px solid lightgray'}}
                     key={matrice.id}>
            <Grid item xs={12} md={2}>
                <Grid item xs={12} style={{fontWeight: 'bolder'}}>{matrice.name}</Grid>
                {!roll ?
                    <>
                <Grid item xs={12}>Kreis {matrice.rank}</Grid>
                {matrice.can_hold_threads ?
                    <Grid item xs={12} style={{fontSize: 'smaller', fontStyle: 'italic', paddingLeft: 8}}>
                        Kann Faden halten
                    </Grid>
                    : null}
                {matrice.tid ? <Grid item xs={12}>Talent {matrice.free ? ',frei' : null}</Grid> :
                    <Grid item xs={12}>
                        <Button className={'btn'} size="small" onClick={() => setMatriceEditOpen(matrice.id)}>
                            <EditIcon/>
                        </Button>
                    </Grid>}
                    </>:null}
            </Grid>
            <Grid item md={10} xs={12}>
                {s_char_matricespells.value
                    .filter(ms => ms.mid === matrice.id)
                    .map((spell, i, j) => <Grid container
                                                style={{
                                                    borderBottom: j.length - 1 == i ? '' : '1px solid lightgray'
                                                }}
                                                key={v4()}
                    >
                        <Item>
                            <Grid container>
                                <Grid item xs={12} sm={6} md={4}>

                                    <Grid item xs={12} md={6}>{spell.name} </Grid>
                                    {!roll&&<Grid item xs={12} md={6}>({spell.discipline} Kreis: {spell.circle})</Grid>}

                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>

                                    <div>Gewobene Fäden {spell.threadswoven}</div>
                                    <div>Benötigte Fäden {spell.threads}</div>

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} style={{justifyContent: 'space-between'}}>
                                    <Button disabled={!canWeave(matrice, spell)}
                                            size="small" onClick={() => weaveThread(matrice, spell)}>
                                        <AirIcon/>
                                    </Button>
                                    <Button disabled={!(spell.threads <= spell.threadswoven)}
                                            size="small" onClick={() => castSpell(matrice, spell)}>
                                        <StreamSharpIcon/>
                                    </Button>
                                    <Button disabled={!(spell.threadswoven > 0)}
                                            size="small" onClick={() => releaseThreads(spell)}>
                                        <ContentCutIcon/>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Item>
                    </Grid>)}

            </Grid>


        </Grid>
    }


    const inventarspellRow = (spell: ICharInventarSpell) => {
        return <TableRow key={spell.id}>
            <TableCell style={{width: '48%'}}>
                {spell.name} Kreis: {spell.circle} {spell.discipline}
            </TableCell>
            <TableCell style={{width: '48%'}}>
                {rowSpellData(spell.name)}
            </TableCell>

            <TableCell style={{width: '1%'}}>
                <Button onClick={(e) => handleSpellPopOpen(spell.name, e)}><QuestionMarkIcon/></Button>
                <Button className={'btn'} id="post" onClick={() => removeInventarSpell(spell)}><DeleteIcon/></Button>
            </TableCell>
            {spell.note !== '' ? <TableCell style={{width: '100%'}}>{spell.note}</TableCell> : null}
        </TableRow>
    }

    const rowSpellData = (name: string) => {
        let spell = SpellsSubscriber.value.find((s) => s.name === name);
        if (!spell || !spell.discipline) return null;
        if (s_app_mobile.value) return <div>
            <div>Fäden: {spell.threads}</div>
            <div>WebSchw: {spell.weaving}/{spell.attune}</div>
            <div>WirkSchw: {spell.casting}</div>
            <div>Wirkung: {spell.eff}</div>
        </div>
        return <div>
            <div>Fäden: {spell.threads} WebSchw: {spell.weaving}/{spell.attune} WirkSchw: {spell.casting}</div>
            <div>Wirkung: {spell.eff}</div>
        </div>
    }

    const grimoirespellRow = (spell: ICharGrimoireSpell) => {
        return <TableRow key={spell.id}>
            <TableCell style={{width: '48%'}}>
                {spell.name} Kreis: {spell.circle} {spell.discipline}
            </TableCell>

            <TableCell style={{width: '48%'}}>
                {rowSpellData(spell.name)}
            </TableCell>

            <TableCell style={{width: '1%'}}>
                <Button onClick={(e) => handleSpellPopOpen(spell.name, e)}>
                    <QuestionMarkIcon/>
                </Button>

                <Button size="small"
                        id="post"
                        onClick={() => setAttuneMatrixOpen(spell.name)}>
                    <SaveAltIcon/>
                </Button>
            </TableCell>
        </TableRow>
    }

    const castingClose = (open: boolean) => {
        if (!open) setCast('')
    }

    const weavingClose = (open: boolean) => {
        if (!open) setWeave('')
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px"}}>Matrixen & Sprüche</h3>
        <Grid container style={{maxHeight: (s_char_matrices.value.length > 0 ? 585 : 185)}}>
            <Grid item xs={10}>
                <h4>Matrixen</h4>
            </Grid>
            <Grid item xs={2}>
                <AddIcon onClick={() => setMatriceAddOpen(true)}/>
            </Grid>
            {s_char_matrices.value.map((row, i, j) => matrixRow(row, j.length, i))}
        </Grid>

        {roll?null:<TableContainer style={{maxHeight: (s_char_grimoirespells.value.length > 0 ? 585 : 185)}}>
            <Table stickyHeader style={{width: '100%'}}>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2} style={{width: '99%'}}><h4>Grimoire</h4></TableCell>
                        <TableCell style={{width: '1%'}}>
                            <AddIcon onClick={() => setLearnSpellOpen(true)}/>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {s_char_grimoirespells.value.map((row) => grimoirespellRow(row))}
                </TableBody>
            </Table>
        </TableContainer>}

        {roll?null:<TableContainer style={{maxHeight: (s_char_inventarSpells.value.length > 0 ? 585 : 185)}}>
            <Table stickyHeader style={{width: '100%'}}>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2} style={{width: '99%'}}><h4>Inventar</h4></TableCell>
                        <TableCell style={{width: '1%'}}>
                            <AddIcon onClick={() => setAddInventarSpellOpen(true)}/>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {s_char_inventarSpells.value.map((row) => inventarspellRow(row))}
                </TableBody>
            </Table>
        </TableContainer>}

        {learnSpellOpen ? <DialogLearning open={learnSpellOpen}
                                          isOpen={(open) => setLearnSpellOpen(open)}
            />
            : null}

        {addInventarSpellOpen ? <DialogAddInventar open={addInventarSpellOpen}
                                                   isOpen={(e) => setAddInventarSpellOpen(e)}
        /> : null}


        {attuneMatrixOpen ? <MatriceSpellAttune open={attuneMatrixOpen}
                                                isOpen={(e) => setAttuneMatrixOpen(e)}/> : null}

        {matriceAddOpen ? <MatriceAdd open={matriceAddOpen} isOpen={(e) => setMatriceAddOpen(e)}/> : null}


        {matriceEditOpen ? <MatriceEdit open={matriceEditOpen}
                                        isOpen={(e) => setMatriceEditOpen(e)}/> : null}

        {cast ? <MatriceSpellCasting cast={cast}
                                     isOpen={(e) => castingClose(e)}/> : null}


        {weave ? <MatriceSpellWeaving weave={weave}
                                      isOpen={(e) => weavingClose(e)}/> : null}
    </Paper>
}

export default MatriceSpell;
